import React, { useState, useEffect } from "react";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import generator from "generate-password";
import Loading from "../../components/Common/Loading";

function Roles(props) {
  const [roles, setRoles] = useState([]);
  const user = useSelector((state) => state.User);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  const allFields = watch();

  // console.log("selectedItem", selectedItem);

  // get users
  const getRoles = () => {
    setIsLoading(true);
    apiReq(url.GET_ROLE, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setRoles(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getRoles();
  }, []);

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // Handle edit role
  const handleEdit = (item) => {
    setSelectedItem(item);
    setValue("title", item.title);
    setValue("description", item.description);
    setIsOpenModal(true);
  };

  // TODO: columns
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          {record.title !== "Admin" && (
            <>
              <button
                className="btn btn-success btn-sm mr-2"
                onClick={() => handleEdit(record)}
              >
                <i className="ri-pencil-line"></i>
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {user.user?._id !== record._id ? (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(record._id)}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              ) : (
                <button
                  className="btn btn-danger btn-sm"
                  style={{ opacity: 0.5 }}
                  onClick={() => {
                    Swal.fire({
                      title: "Oops...",
                      text: "You can not delete your own account",
                      icon: "error",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "<Strong>Are you absolutely sure?</Strong>",
      html: "Please type <Strong>DELETE</Strong> to confirm.",
      input: "text",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === "DELETE") {
          apiReq(url.DELETE_ROLE + id, {}, "delete", {
            Authorization: `Bearer ${user.user?.token}`,
          })
            .then((res) => {
              if (res.success) {
                Swal.fire({
                  title: "Deleted!",
                  text: res.message,
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                getRoles();
              }
            })
            .catch((err) => {
              console.log("err>>>", err);
            });
        } else {
          Swal.fire({
            title: "Cancelled",
            text: "Your data is safe :)",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_ROLE,
        {
          title: data.title,
          description: data.description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getRoles();
            setIsOpenModal(false);
            setSelectedItem(null);
            setIsLoading(false);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_ROLE + selectedItem._id,
        {
          title: data.title,
          description: data.description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getRoles();
            setIsOpenModal(false);
            setSelectedItem(null);
            setIsLoading(false);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null
              ? `Update: ${allFields?.title}`
              : "Add new role"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("title", { required: true })}
                />
                {errors.title && (
                  <span className="text-danger">Title is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Description</label>
                <textarea
                  className="form-control"
                  placeholder="Description"
                  {...register("description", { required: false })}
                ></textarea>
              </div>

              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Roles</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => setIsOpenModal(!isOpenModal)}
                    >
                      Add new role
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={roles}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Roles;
